import NodeModule from '../../services/NodeModule';
import Form from './views/Form';
import UserUpdateLostPasswordFormValidator from './views/UserUpdateLostPasswordFormValidator';

export default class UserUpdateLostPasswordNode extends NodeModule {
  start(options) {
    console.log('Starting User Update Lost Password');
    const userLostPassword = new Form({el: options.el, formEl: '#userForm', type: (opts) => new UserUpdateLostPasswordFormValidator(opts)});
  }
}